<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-items-end tw-mb-4">
      <button
        @click="navigateToCreateSupplierBankAccount"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('suppliers.titles.new_bank_account') }}
      </button>
    </div>
    <SupplierBankAccountsFancyTable :customer-id="String(selectedCustomerId)" />
  </div>
</template>

<script setup lang="ts">
import SupplierBankAccountsFancyTable from './Table/SupplierBankAccountsFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import router from '@/router';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';
import { useCustomerStore } from '@/stores/customer.store';

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

const navigateToCreateSupplierBankAccount = () => {
  router.push({ name: 'create-supplier-bank-account' });
};

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.master_data',
    },
    {
      labelKey: 'sidebar.items.supplier_bank_accounts',
    },
  ]);
});
</script>
